import type { VV } from '@semios/app-platform-value-type-definitions'
import moment from 'moment-timezone'
import { unitConverter } from 'utils/unitConverter/unitConverter'

/**
 * This function is needed for diseases (i.e. GPM,CPM) that show rain on a daily chart
 * but the rain data is being fetched hourly also.
 * @param rainSeries hourly rain data
 * @param timezone property timezone
 * @returns rain data aggregated by the day in the format of [timestamp, value]
 */
export const makeDailyRainForDiseases = (
  rainSeries: VV.DomainTypes.Weather.TValuesReturnWithMetaIgnoringKeying['points']['precipitation'][number]['timeseries'],
  timezone: string,
): Array<[number, number | null]> => {
  const dataByLocalDate = rainSeries.reduce(
    (acc, d) => {
      const localDate = moment.tz(d.timestamp, timezone).format('YYYY-MM-DD')

      if (!acc[localDate]) {
        acc[localDate] = 0
      }

      acc[localDate] += d.value?.sum ?? 0

      return acc
    },
    {} as Record<string, number | null>,
  )

  return Object.entries(dataByLocalDate).map(([localDate, value]) => [
    +moment.tz(localDate, timezone).startOf('day'),
    unitConverter.precipitation(value).value(),
  ])
}
